import { render, staticRenderFns } from "./YiZheng.vue?vue&type=template&id=138c9262&scoped=true&"
import script from "./YiZheng.vue?vue&type=script&lang=js&"
export * from "./YiZheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c9262",
  null
  
)

export default component.exports